export interface CaseProfilePayload {
  posture: 'first_party' | 'third_party' | null;
  posture_source: 'attorney' | 'wizard' | 'inferred' | null;
  posture_confirmed: boolean;
  damages_model: 'standard_bi' | 'future_closure' | string | null;
  pillars: string[];
  apply_first_party_cap: boolean;
  ceiling_basis: string | null;
  set_by: string | null;
  set_at: string | null; // ISO
  schema_version: string; // "1.0"
}

export function postureLabel(posture: CaseProfilePayload['posture']): string {
  if (posture === 'first_party') return 'FIRST-PARTY';
  if (posture === 'third_party') return 'THIRD-PARTY';
  return '—';
}

export function modelLabel(model: CaseProfilePayload['damages_model']): string {
  if (model === 'standard_bi') return 'STANDARD BI';
  if (model === 'future_closure') return 'FUTURE CLOSURE';
  return '—';
}

export function formatSetAt(iso?: string | null): string {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return '';
  }
}
